type BuildNsjTableInlineMobileLabelOptions = {
    showOnMobile?: boolean;
};

function buildInlineMobileLabelMarkup(
    label: string,
    classPrefix: string,
    options: BuildNsjTableInlineMobileLabelOptions = {}
): string {
    const classes = [classPrefix];

    if (options.showOnMobile === false) {
        classes.push(`${classPrefix}--hidden-mobile`);
    }

    return `<span class="${classes.join(' ')}">${label}</span>`;
}

export function buildNsjTableInlineMobileLabel(
  label: string,
  options: BuildNsjTableInlineMobileLabelOptions = {}
): () => string {
    return () => buildInlineMobileLabelMarkup(label, 'nsj-table-inline-label-mobile__label', options);
}

export function buildNsjTableManualInlineMobileLabel(
    label: string,
    options: BuildNsjTableInlineMobileLabelOptions = {}
): string {
    return buildInlineMobileLabelMarkup(label, 'nsj-table-manual-inline-label-mobile__label', options);
}

export function applyNsjTableInlineMobileLabels<T extends { label?: string; customLabelHtml?: () => string }>(fields: T[]): T[] {
    return fields.map((field) => {
        if (
            typeof field.customLabelHtml === 'function' ||
            typeof field.label !== 'string' ||
            field.label.trim() === ''
        ) {
            return field;
        }

        return {
            ...field,
            customLabelHtml: buildNsjTableInlineMobileLabel(field.label.trim())
        };
    });
}
